<template>
    <v-container grid-list-md>
        <h2 class="hidden-sm-and-down mb-3">{{ txc.page_title }}</h2>
        <div class="product-list" v-if="items.length > 0">
            <ns-product-card
                v-for="item in items"
                forcesv
                :sku="item.sku || item.SKU"
                :key="item.sku || item.SKU"
                @favorite-click="handleFavoriteClick"
                @added-to-cart="handleAddedToCart"
                @card-click="handleCardClick(item.sku)"
            />
        </div>
        <loader v-show="processing" />
        <v-card flat v-if="noResults" data-test="no-results">
            <v-card-text>{{ txc.no_favorites_text }}</v-card-text>
        </v-card>
        <ns-toast
            :success="toastType == 'success' ? true : false"
            :error="toastType == 'error' ? true : false"
            icon
            :show-trigger="showTrigger"
            :message="toastMessage"
        />
    </v-container>
</template>

<script>
import { ProfileService } from '@nuskin/ns-account'
import { FavoritesService } from '@nuskin/ns-shop'
import { mapGetters } from 'vuex'
import profileUtils from '../repositories/profileUtils'
import Loader from '../components/Loader'
import { NsProductCard } from '@nuskin/product-components'
import { NsToast } from '@nuskin/design-components'
import genhelpmethods from '../helpers/genhelpmethods'
import favouriteshelper from '../helpers/components/favourites'
export default {
    name: 'Favorites',
    data() {
        return {
            items: [],
            processing: false,
            noResults: false,
            showTrigger: false,
            toastMessage: '',
            toastType: null
        }
    },
    components: {
        Loader,
        NsToast,
        NsProductCard
    },
    computed: {
        ...mapGetters({
            txc: 'translationsFavorites',
            txcg: 'translationsGlobal',
            account: 'account',
            market: 'marketLoggedIn',
            language: 'languageLoggedIn'
        })
    },
    methods: {
        isItemNotAvailable(status) {
            return genhelpmethods.isItemNotAvailable(status)
        },
        handleCardClick(sku) {
            let locale = profileUtils.getLanguage() + '_' + profileUtils.getCountry();
            if(locale === 'ja_JP') {
                window.location.assign(`/content/markets/${locale}/products/product.${sku}.html`)
            } else {
                window.location.assign(`/content/nuskin/${locale}/products/product.${sku}.html`)
            }
        },
        handleFavoriteClick(item) {
            favouriteshelper.handleFavoriteClick(this, profileUtils, item)
        },
        handleAddedToCart(item) {
            favouriteshelper.handleAddedToCart(this, profileUtils, item)
        }
    },
    mounted() {
        favouriteshelper.mounted(this, FavoritesService, ProfileService)
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.v-dialog {
  .container {
    margin: 0;
  }
}

.product-list {
  display: grid;
  grid-template-columns: repeat(2, 275px);
  grid-gap: 15px;
  justify-content: center;
  margin: 0 auto;
  width: 100%;
  max-width: 1440px;
  .ns-product-card__action .ns-animate-height {
    max-height: 157px !important;
  }
}

@media (max-width: 767px) {
  .product-list {
    grid-template-columns: 100%;
    grid-gap: 5px;
    padding: 10px 0;
  }
}
</style>
